import {mapState} from "vuex";
import util from "@/mixins/util";
import {getTokenObj, loginTokenSet} from "@/mixins/Auth";
import EventBus from "@/utils/event-bus";
import alertMixins from "@/mixins/alertMixins";
import {
    clearLoginState,
    getLoginErrorMessage,
    getLoginLevelObj,
    isAllowedLoginGroupType,
} from "@/mixins/loginAccess";

export default {
    mixins: [alertMixins],
    computed: {
        ...mapState({
            UserInfo: state => state.userInfo.UserInfo,
        })
    },
    methods: {
        isLogin() {
            return !util.isEmpty(this.UserInfo) && !util.isEmpty(this.UserInfo.mb_no);
        },
        loginSns(result, type='naver') {
            if (result.token) {
                loginTokenSet(result.token);
            }
            this.$localStorage.set('snsResult', '');
            this.checkSnsLoginLevel().then(isAllowed => {
                EventBus.$emit('apiLoading', false);
                if (!isAllowed) {
                    return false;
                }

                if (result.mb_is_verify != 1) {
                    let tokenObj = getTokenObj();
                    this.$store.dispatch('userInfo/setUserInfo', {token: result.token,});

                    /*if (type != 'google' || type != 'facebook') {
                        window.close();
                    }*/
                    if (window.hasOwnProperty('opener') && !util.isEmpty(window.opener)) {
                        window.opener.location.href = "/auth/register/sns";
                        setTimeout(() => {
                            window.close();
                        }, 500)
                       /* if(type != 'naver') {
                            window.close();
                        }*/

                    }else{
                        this.$router.push(`/auth/register/sns`);
                    }
                } else {
                    /*if(type != 'google' && type != 'facebook') {
                        window.close();
                    }*/
                    if(window.hasOwnProperty('opener') && !util.isEmpty(window.opener)) {
                        window.opener.location.href = "/";
                        window.close();
                    }
                    this.$router.push(`/`);
                }
            });

        },
        checkSnsLoginLevel() {
            let tokenObj = getTokenObj();
            if (util.isEmpty(tokenObj) || util.isEmpty(tokenObj.g_idx)) {
                this.loginAccessFail();
                return Promise.resolve(false);
            }

            return this.$api.$config.getGroup().then(res => res.Data.Result).then(res => {
                if (res.Info.type !== 1) {
                    this.loginAccessFail();
                    return false;
                }

                let levelObj = getLoginLevelObj(tokenObj.g_idx, res.List);
                if (util.isEmpty(levelObj) || !isAllowedLoginGroupType(levelObj.type)) {
                    this.loginAccessFail();
                    return false;
                }

                return true;
            }).catch(() => {
                this.loginAccessFail();
                return false;
            });
        },
        loginAccessFail(errorMsg = '') {
            let msg = errorMsg || getLoginErrorMessage(this);
            this.errorMsg = msg;
            this.errorAlert(msg);
            clearLoginState(this);
        },
        getMyPoint() {
            if (util.isEmpty(this.UserInfo) || util.isEmpty(this.UserInfo.point) || isNaN(this.UserInfo.point)) {
                return 0
            }
            return Number(this.UserInfo.point);
        },
        getMemberType() {
            if (!util.isEmpty(this.UserInfo) && this.UserInfo.g_idx === 2) {
                return 'curator';
            }
            return 'normal';
        },
        getIsPremium() {
            if (!util.isEmpty(this.UserInfo) && this.UserInfo.mb_premium === 1) {
                return 'premium';
            }
            return false;
        },
        returnSocialType() {
            if (!util.isEmpty(this.UserInfo)) {
                if (util.isEmpty(this.UserInfo.Social)) {
                    return 'email';
                } else {
                    // return this.UserInfo.Social.social_type;
                    return this.UserInfo.Social.social_type;
                }
            }


        },
        langCheckLine(value) {
            switch (value) {
                case 'ko':
                    return 1;
                case 'en':
                    return 30;
                default:
                    return '';
            }
        },
        isAuthenticated() {
            return !util.isEmpty(this.UserInfo.mb_hp) && !util.isEmpty(this.UserInfo.mb_name)
        },
    },
}
